import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";


// components
import LabelsList from "./_list";
import LabelForm from "./_form";
import {showLoader} from "../../../../components/loader/loader";
import {GenericButton} from "../../../../components/buttons/customButtons";

// actions
import {ADD_STATE, REMOVE_STATE, setItem, setForm} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";
import LinkedLabels from "./LinkedLabels";



const Labels = (props) => {
    const path = `${props.path}/labels`;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    const [showFormModal, setShowFormModal] = useState(false);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    const onCreateItem = () => {
        props.setItem(path, null);
        props.setForm(path)
        setShowFormModal(!showFormModal);
    }

    const onEditItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false)
        setShowFormModal(!showFormModal);
    }

    const handleShowFormModal = () => setShowFormModal(!showFormModal);



    return <>
        {loading && showLoader()}

        <Card className={'internal-card'}>
            <CardTitle className="internal-title-card">
                <i className="far fa-edit"/> Etiquetas
                <div className="top-right actions">
                    <GenericButton
                        style={'table'}
                        label={'Nueva Etiqueta'}
                        toolTip={'Nueva Etiqueta'}
                        icon={'fa-plus'}
                        permission={'add'}
                        onClick={onCreateItem}
                    />
                </div>
            </CardTitle>
            <CardBody className={'internal-body-card'}>
                <LinkedLabels path={props.path} />
                <LabelsList
                    path={props.path}
                    toggleModal={handleShowFormModal}
                    onEdit={onEditItem}
                />
            </CardBody>
        </Card>

        {
            showFormModal && <LabelForm
                path={props.path}
                isOpen={showFormModal}
                toggle={handleShowFormModal}
            />
        }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem, setForm
})

export default connect(mapStateToProps, mapActionsToProps)(Labels);